import {Component} from 'react';
import h from 'react-hyperscript';
import Image from 'Components/Image/Image';
import content from 'Assets/data/header.json';

class NavbarUpper extends Component {
  render() {
    return (
      h('div', {
        id: this.props.id,
        className: 'header__upper',
      },
      h('a', {
        href: content.edu_href,
      }, h(Image, {
        id: 'header__upper-image',
        key: 'header__upper-image',
        src: content.edu_logo,
        className: 'header__logo',
        alt: 'Google Edu Logo',
      }, null))
      )
    );
  }
}

export default NavbarUpper;
